export default "__VITE_ASSET__168054f2__"